<template>
	<!-- 关于我们 -->
	<div class="about">
		<!-- top -->
		<headers/>
		<!-- 内容 -->
		<div class="common">
			<div class="banner">
				<div class="bannerCont">
					<p class="p1">定制软件开发 · 移动互联，创造未来</span></p>
					<p class="p2">由高学历、高素质人才组成团队，形成了科学的管理体系，为您的定制软件保驾护航；</p>
					<p class="p2">360行行业众多案例供您参考任您选择，行业解决方案、高品质交付、终身迭代无忧！</p>
				</div>
			</div>
			<!-- 位置 -->
			<div class="site">
				<span class="square"></span>
				<p>您的位置： 首页  <span>></span>   软件定制</p>
			</div>
			<!-- 软件定制 -->
			<div class="software">
				<p class="backImg">技术积累成就行业导航</p>
				<div class="public">
					<div class="number">
						<div class="item">
							<p class="num">100 <span>+</span></p>
							<p class="name">产品服务</p>
						</div>
						<div class="item">
							<p class="num">30 <span>+</span></p>
							<p class="name">合作商家</p>
						</div>
						<div class="item">
							<p class="num">10 <span>+</span></p>
							<p class="name">多年运行</p>
						</div>
						<div class="item">
							<p class="num">100 <span>+</span></p>
							<p class="name">口碑好评</p>
						</div>
					</div>
					<div class="type">
						<div class="items">
							<img src="../../assets/images/person.gif" alt="" class="icon">
							<div class="person">
								<p class="names">个人用户</p>
								<p class="titles">模块制定、众创定制、专属定制满足您的多种个性化需求</p>
							</div>
						</div>
						<div class="items">
							<img src="../../assets/images/person.gif" alt="" class="icon">
							<div class="person">
								<p class="names">企业用户</p>
								<p class="titles">为您提供跨行业跨领域的多种企业解决方案及云服务</p>
							</div>
						</div>
						<div class="items">
							<img src="../../assets/images/person.gif" alt="" class="icon">
							<div class="person">
								<p class="names">开发者</p>
								<p class="titles">平台为您提供各种开发工具，数据化运营，持续创新</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="quest">
				<h1>我们致力于解决您的问题</h1>
				<p>我们的开发团队是遥遥领先通过创新，基于未来的技术和您的需求为客户改善产品，努力将更好的用户体验带给您。</p>
			</div>
			<div class="software">
				<p class="backImg">软件定制服务</p>
				<div class="public serverList">
					<div class="item">
						<div class="dminIMG">
							<img src="../../assets/images/admin.png" alt="">
						</div>
						<h1>后台系统开发</h1>
						<p>为用户提供各种定制化后台系统开发服务，提供可视化的数据后台，良好的界面交互，全面兼容不同设备，不同浏览器。</p>
					</div>
					<div class="item">
						<div class="dminIMG">
							<img src="../../assets/images/app.png" alt="">
						</div>
						<h1>APP定制</h1>
						<p>根据您的需求定制各类安卓APP,我们致力于为您提供高品质的一站式安卓APP开发解决方案,助力您的智能生活。</p>
					</div>
					<div class="item">
						<div class="dminIMG">
							<img src="../../assets/images/qianru.png" alt="">
						</div>
						<h1>嵌入式软件开发</h1>
						<p>系统化设计指导下的硬件、软件以及综合研发。</p>
					</div>
					<div class="item">
						<div class="dminIMG">
							<img src="../../assets/images/wat.png" alt="">
						</div>
						<h1>微信小程序</h1>
						<p>根据您的需求定制各类微信小程序，我们致力于为您提供高品质的开发解决方案和定制开发。</p>
					</div>
				</div>
			</div>
			<div class="software">
				<p class="backImg">软件定制开发流程</p>
				<div class="softprocess">
					<img src="../../assets/images/softprocess.png" alt="">
				</div>
			</div>
		</div>
		<!-- bottom -->
		<footers></footers>
	</div>
</template>

<script>
	import headers from '@/components/header.vue'
	import footers from '@/components/footer.vue'
	export default{
		data(){
			return{
				
			}
		},
		methods:{
		    
		},
		components:{
			headers,footers
		}
	}
</script>

<style lang="scss">
	.banner{
		width: 100%;
		height:844px;
		margin: 0 auto;
		vertical-align: middle;
		position: relative;
		background: url(../../assets/images/software.gif) top center no-repeat;
		background-size:100% 100%;
		text-align: center;
		.bannerCont{
			width: 1200px;
			height: 380px;
			padding-top: 200px;
			color: #fff;
			margin: 0 auto;
			text-align:left;
			.p1{
				font-size: 40px;
				padding: 10px;
				font-weight: bold;
			}
			.p2{
				font-size:12px;
				padding: 5px 0;
				letter-spacing: 5px;
				display: inline-block;
				margin: 5px 0;
			}
		}
	}
	.site{
		width: 1200px;
		height: 36px;
		display: flex;
		flex-direction: row;
		align-items: center;
		text-align: left;
		font-size:16px;
		color:#333;
		margin: 30px auto;
		border-bottom:1px dashed #ccc;
		.square{
			display: inline-block;
			width: 10px;
			height: 20px;
			background: #000;
			margin-right: 10px;
		}
		p{
			span{
				padding: 0 5px;
			}
		}
	}
	.public{
		width: 1200px;
		margin: 0 auto;
	}
	.quest{
		width: 100%;
		background: #2359e2;
		text-align: center;
		color: #fff;
		height:200px;
		h1{
			font-size: 30px;
			padding-top: 60px;
		}
		p{
			font-size: 16px;
			line-height: 60px;
		}
	}
	.software{
		margin-top:50px;
		position:relative;
		.backImg{
			height: 80px;
			font-size: 38px;
			color: #3C77F0;
			line-height: 80px;
			font-weight: bold;
			background: url(../../assets/images/softImg.gif) center no-repeat;
		}
		.number{
			display: flex;
			flex-direction: row;
			align-items: center;
			margin:50px 0;
			.item{
				width: 25%;
				.num{
					font-size:50px ;
					span{
						font-size: 24px;
					}
				}
				.name{
					font-size: 16px;
				}
			}
		}
		.serverList{
			display: flex;
			flex-direction: row;
			padding:50px 0;
			.item{
				width: 22%;
				margin-right: 4%;
				height: 400px;
				background:#fff;
				box-shadow: 0 0 15px #e0e0e0;
				h1{
					font-size: 18px;
				}
				p{
					font-size: 16px;
					text-indent: 32px;
					padding: 30px 10px ;
					letter-spacing: 1px;
				}
				.dminIMG{
					padding: 20px;
					height: 150px;
					img{
						width: 100%;
						height: auto;
					}
				}
			}
		}
		.type{
			display: flex;
			flex-direction: row;
			align-items: center;
			margin:50px 0;
			padding-top:30px;
			.items{
				width: 30%;
				margin-right: 5%;
				display: flex;
				flex-direction: row;
				text-align:left;
				&:last-child{
					margin-right: 0;
				}
				.icon{
					width:40px;
					height: 40px;
				}
				.person{
					margin-left: 20px;
					.names{
						font-size: 18px;
						font-weight: bold;
					}
					.titles{
						margin-top: 15px;
						font-size: 16px;
					}
				}
			}
		}
	}
	.softprocess{
		margin-top: -30px;
	}
</style>



// WEBPACK FOOTER //
// src/views/software/software.vue